export interface SubSubCategory {
  id: string;
  name: string;
  nameKr: string;
}

export interface SubCategory {
  id: string;
  name: string;
  nameKr: string;
  productCount: number;
  subSubCategories?: SubSubCategory[];
}

export interface Category {
  id: string;
  code: string;
  name: string;
  nameKr: string;
  description: string;
  image: string;
  productCount: number;
  subCategories: SubCategory[];
  color: string;
}

export const categories: Category[] = [
  {
    id: "cat-cn",
    code: "1",
    name: "Vật Liệu Carbon & Nano",
    nameKr: "탄소·나노 원소재",
    description: "Sợi carbon, CNT, Graphene, Nhựa composite hiệu suất cao",
    image: "https://readdy.ai/api/search-image?query=carbon%20fiber%20nano%20material%20CNT%20graphene%20resin%20composite%20futuristic%20industrial%20close%20up%20texture%20dark%20metallic%20sheen%20professional%20studio%20photography%20clean%20minimal%20background&width=400&height=300&seq=cat_cn1&orientation=landscape",
    productCount: 999,
    color: "from-gray-800 to-gray-900",
    subCategories: [
      {
        id: "sub-cn1", name: "Sợi Carbon", nameKr: "탄소섬유", productCount: 320,
        subSubCategories: [
          { id: "ssub-cn1-1", name: "Carbon Fiber Prepreg", nameKr: "탄소섬유 프리프레그" },
          { id: "ssub-cn1-2", name: "Vải Carbon (Fabric)", nameKr: "탄소섬유 직물" },
          { id: "ssub-cn1-3", name: "Carbon Fiber Chopped", nameKr: "탄소섬유 촙" },
          { id: "ssub-cn1-4", name: "Carbon Fiber Tow", nameKr: "탄소섬유 토우" },
          { id: "ssub-cn1-5", name: "Carbon Fiber UD Tape", nameKr: "UD 테이프" },
        ],
      },
      {
        id: "sub-cn2", name: "CNT (Ống Nano Carbon)", nameKr: "CNT (탄소나노튜브)", productCount: 210,
        subSubCategories: [
          { id: "ssub-cn2-1", name: "CNT Đơn Tường (SWCNT)", nameKr: "단일벽 CNT (SWCNT)" },
          { id: "ssub-cn2-2", name: "CNT Đa Tường (MWCNT)", nameKr: "다중벽 CNT (MWCNT)" },
          { id: "ssub-cn2-3", name: "CNT Chức Năng Hóa", nameKr: "기능화 CNT" },
          { id: "ssub-cn2-4", name: "CNT Masterbatch", nameKr: "CNT 마스터배치" },
          { id: "ssub-cn2-5", name: "CNT Phân Tán (Slurry)", nameKr: "CNT 분산 슬러리" },
        ],
      },
      {
        id: "sub-cn3", name: "Graphene", nameKr: "그래핀", productCount: 185,
        subSubCategories: [
          { id: "ssub-cn3-1", name: "Graphene Oxide (GO)", nameKr: "그래핀 옥사이드 (GO)" },
          { id: "ssub-cn3-2", name: "Reduced Graphene Oxide (rGO)", nameKr: "환원 그래핀 옥사이드 (rGO)" },
          { id: "ssub-cn3-3", name: "Graphene Nanoplatelet", nameKr: "그래핀 나노플레이트렛" },
          { id: "ssub-cn3-4", name: "Graphene Tấm (Film)", nameKr: "그래핀 필름" },
          { id: "ssub-cn3-5", name: "Graphene Bột", nameKr: "그래핀 분말" },
        ],
      },
      {
        id: "sub-cn4", name: "Nhựa Composite (Resin)", nameKr: "수지 (Resin)", productCount: 165,
        subSubCategories: [
          { id: "ssub-cn4-1", name: "Epoxy Resin", nameKr: "에폭시 수지" },
          { id: "ssub-cn4-2", name: "Polyester Resin", nameKr: "폴리에스터 수지" },
          { id: "ssub-cn4-3", name: "Vinyl Ester Resin", nameKr: "비닐에스터 수지" },
          { id: "ssub-cn4-4", name: "Nhựa Nhiệt Dẻo (Thermoplastic)", nameKr: "열가소성 수지" },
          { id: "ssub-cn4-5", name: "Benzoxazine Resin", nameKr: "벤조옥사진 수지" },
        ],
      },
      {
        id: "sub-cn5", name: "Vật Liệu Composite Cao Cấp", nameKr: "고기능성 복합재료 소재", productCount: 79,
        subSubCategories: [
          { id: "ssub-cn5-1", name: "Carbon/Kevlar Hybrid", nameKr: "탄소/케블라 하이브리드 복합재" },
          { id: "ssub-cn5-2", name: "Nano Reinforced Composite", nameKr: "나노 강화 복합재" },
          { id: "ssub-cn5-3", name: "Ceramic Matrix Composite", nameKr: "세라믹 복합재" },
          { id: "ssub-cn5-4", name: "Metal Matrix Composite", nameKr: "금속 기지 복합재" },
        ],
      },
      {
        id: "sub-cn6", name: "Khác", nameKr: "기타", productCount: 40,
        subSubCategories: [
          { id: "ssub-cn6-1", name: "Vật Liệu Nano Khác", nameKr: "기타 나노 소재" },
          { id: "ssub-cn6-2", name: "Vật Liệu Nghiên Cứu", nameKr: "연구개발용 소재" },
        ],
      },
    ],
  },
  {
    id: "cat-mob",
    code: "2",
    name: "Giao Thông Tương Lai",
    nameKr: "미래 모빌리티",
    description: "Linh kiện nhẹ ô tô, cấu trúc máy bay, khung drone, composite tàu thủy & đường sắt",
    image: "https://readdy.ai/api/search-image?query=futuristic%20mobility%20lightweight%20automotive%20aerospace%20drone%20carbon%20composite%20parts%20Korean%20technology%20advanced%20transportation%20modern%20design%20studio&width=400&height=300&seq=cat_mob1&orientation=landscape",
    productCount: 999,
    color: "from-slate-700 to-slate-900",
    subCategories: [
      {
        id: "sub-mob1", name: "Linh Kiện Nhẹ Hóa Ô Tô", nameKr: "자동차 경량화 부품", productCount: 420,
        subSubCategories: [
          { id: "ssub-mob1-1", name: "Tấm Thân Xe CFRP", nameKr: "CFRP 차체 패널" },
          { id: "ssub-mob1-2", name: "Nắp Capô Carbon", nameKr: "탄소섬유 후드" },
          { id: "ssub-mob1-3", name: "Cửa Xe Carbon", nameKr: "탄소섬유 도어" },
          { id: "ssub-mob1-4", name: "Khung Gầm Nhẹ", nameKr: "경량화 샤시 부품" },
          { id: "ssub-mob1-5", name: "Bánh Xe Composite", nameKr: "복합재 휠" },
        ],
      },
      {
        id: "sub-mob2", name: "Cấu Trúc Máy Bay", nameKr: "항공기 구조체", productCount: 280,
        subSubCategories: [
          { id: "ssub-mob2-1", name: "Thanh Cánh Máy Bay (Wing Spar)", nameKr: "날개 스파 (Wing Spar)" },
          { id: "ssub-mob2-2", name: "Tấm Thân Máy Bay", nameKr: "동체 패널" },
          { id: "ssub-mob2-3", name: "Nội Thất Máy Bay", nameKr: "항공기 내장재" },
          { id: "ssub-mob2-4", name: "Vỏ Động Cơ (Nacelle)", nameKr: "엔진 나셀" },
          { id: "ssub-mob2-5", name: "Cánh Đuôi Máy Bay", nameKr: "수평·수직 꼬리날개" },
        ],
      },
      {
        id: "sub-mob3", name: "Khung Drone", nameKr: "드론 기체", productCount: 185,
        subSubCategories: [
          { id: "ssub-mob3-1", name: "Khung Drone Công Nghiệp", nameKr: "산업용 드론 프레임" },
          { id: "ssub-mob3-2", name: "Cánh Quạt Drone (Propeller)", nameKr: "드론 프로펠러" },
          { id: "ssub-mob3-3", name: "Bộ Phận Hạ Cánh", nameKr: "드론 랜딩 기어" },
          { id: "ssub-mob3-4", name: "Vỏ Bảo Vệ Drone", nameKr: "드론 하우징" },
        ],
      },
      {
        id: "sub-mob4", name: "Composite Tàu Thủy & Đường Sắt", nameKr: "선박 및 철도용 복합재 부품", productCount: 114,
        subSubCategories: [
          { id: "ssub-mob4-1", name: "Boong Tàu Composite", nameKr: "선박 갑판 복합재" },
          { id: "ssub-mob4-2", name: "Nội Thất Tàu Thủy", nameKr: "선박 내장재" },
          { id: "ssub-mob4-3", name: "Bộ Phận Tàu Hỏa", nameKr: "철도 차량 복합재 부품" },
          { id: "ssub-mob4-4", name: "Nội Thất Tàu Điện", nameKr: "열차 내장재" },
        ],
      },
    ],
  },
  {
    id: "cat-it",
    code: "3",
    name: "IT · Điện Tử & Bán Dẫn",
    nameKr: "IT·전자 및 반도체 소재",
    description: "Linh kiện bán dẫn nền nano, vật liệu tản nhiệt màn hình, cảm biến, vật liệu chắn sóng",
    image: "https://readdy.ai/api/search-image?query=semiconductor%20nano%20material%20IT%20electronic%20components%20display%20heat%20dissipation%20sensor%20electromagnetic%20shielding%20Korean%20tech%20industry%20professional%20photography%20clean%20background&width=400&height=300&seq=cat_it1&orientation=landscape",
    productCount: 999,
    color: "from-zinc-700 to-zinc-900",
    subCategories: [
      {
        id: "sub-it1", name: "Linh Kiện Bán Dẫn Nền Nano", nameKr: "나노 소재 기반 반도체 부품", productCount: 390,
        subSubCategories: [
          { id: "ssub-it1-1", name: "Nano Wire (Dây Nano)", nameKr: "나노와이어" },
          { id: "ssub-it1-2", name: "CNT Transistor", nameKr: "CNT 트랜지스터" },
          { id: "ssub-it1-3", name: "Graphene FET", nameKr: "그래핀 FET" },
          { id: "ssub-it1-4", name: "Nano Substrate (Đế Nano)", nameKr: "나노 기판" },
          { id: "ssub-it1-5", name: "Bột Nano Dẫn Điện", nameKr: "나노 도전성 분말" },
        ],
      },
      {
        id: "sub-it2", name: "Vật Liệu Tản Nhiệt Màn Hình", nameKr: "디스플레이 방열 소재", productCount: 280,
        subSubCategories: [
          { id: "ssub-it2-1", name: "Màng Tản Nhiệt Graphene", nameKr: "그래핀 방열 필름" },
          { id: "ssub-it2-2", name: "Tấm Tản Nhiệt CNT", nameKr: "CNT 방열 시트" },
          { id: "ssub-it2-3", name: "Polymer Dẫn Nhiệt", nameKr: "열전도성 고분자" },
          { id: "ssub-it2-4", name: "TIM (Thermal Interface Material)", nameKr: "열계면 소재 (TIM)" },
        ],
      },
      {
        id: "sub-it3", name: "Cảm Biến (Sensor)", nameKr: "센서", productCount: 210,
        subSubCategories: [
          { id: "ssub-it3-1", name: "Cảm Biến Áp Suất", nameKr: "압력 센서" },
          { id: "ssub-it3-2", name: "Cảm Biến Khí Gas", nameKr: "가스 센서" },
          { id: "ssub-it3-3", name: "Cảm Biến Sinh Học (Bio)", nameKr: "바이오 센서" },
          { id: "ssub-it3-4", name: "Cảm Biến Nhiệt Độ", nameKr: "온도 센서" },
          { id: "ssub-it3-5", name: "Cảm Biến Độ Ẩm", nameKr: "습도 센서" },
        ],
      },
      {
        id: "sub-it4", name: "Vật Liệu Chắn Sóng Điện Từ", nameKr: "전자파 차폐재", productCount: 119,
        subSubCategories: [
          { id: "ssub-it4-1", name: "Màng Chắn EMI", nameKr: "EMI 차폐 필름" },
          { id: "ssub-it4-2", name: "Vật Liệu Hấp Thụ Sóng", nameKr: "전자파 흡수재" },
          { id: "ssub-it4-3", name: "Gioăng Dẫn Điện (Gasket)", nameKr: "도전성 가스켓" },
          { id: "ssub-it4-4", name: "Sơn Chắn Sóng EMC", nameKr: "EMC 차폐 코팅재" },
        ],
      },
    ],
  },
  {
    id: "cat-eq",
    code: "4",
    name: "Thiết Bị & Máy Móc Công Nghiệp",
    nameKr: "공정 장비 및 기계",
    description: "Thiết bị sản xuất sợi carbon, hệ thống xử lý nhiệt, máy phân tán nano, thiết bị tạo hình composite",
    image: "https://readdy.ai/api/search-image?query=industrial%20process%20equipment%20machinery%20carbon%20fiber%20manufacturing%20heat%20treatment%20system%20nano%20dispersion%20machine%20composite%20molding%20Korean%20precision%20factory%20clean%20modern%20setting&width=400&height=300&seq=cat_eq1&orientation=landscape",
    productCount: 999,
    color: "from-neutral-700 to-neutral-900",
    subCategories: [
      {
        id: "sub-eq1", name: "Thiết Bị Sản Xuất Sợi Carbon", nameKr: "탄소섬유 제조 장비", productCount: 340,
        subSubCategories: [
          { id: "ssub-eq1-1", name: "Lò Oxy Hóa (Oxidation Furnace)", nameKr: "산화로" },
          { id: "ssub-eq1-2", name: "Lò Than Hóa (Carbonization)", nameKr: "탄화로" },
          { id: "ssub-eq1-3", name: "Thiết Bị Xử Lý Bề Mặt", nameKr: "표면처리 장비" },
          { id: "ssub-eq1-4", name: "Máy Quấn Sợi (Winding)", nameKr: "와인딩 장비" },
          { id: "ssub-eq1-5", name: "Dây Chuyền Kéo Sợi", nameKr: "방사 설비" },
        ],
      },
      {
        id: "sub-eq2", name: "Hệ Thống Xử Lý Nhiệt", nameKr: "열처리 시스템", productCount: 280,
        subSubCategories: [
          { id: "ssub-eq2-1", name: "Lò Xử Lý Nhiệt Liên Tục", nameKr: "연속식 열처리로" },
          { id: "ssub-eq2-2", name: "Lò Xử Lý Nhiệt Gián Đoạn", nameKr: "배치식 열처리로" },
          { id: "ssub-eq2-3", name: "Lò Chân Không Nhiệt Độ Cao", nameKr: "고온 진공로" },
          { id: "ssub-eq2-4", name: "Lò Nung Thiêu Kết", nameKr: "소결로" },
        ],
      },
      {
        id: "sub-eq3", name: "Máy Phân Tán Nano", nameKr: "나노 분산기", productCount: 220,
        subSubCategories: [
          { id: "ssub-eq3-1", name: "Máy Siêu Âm Phân Tán", nameKr: "초음파 분산기" },
          { id: "ssub-eq3-2", name: "Máy Nghiền Bead Mill", nameKr: "비즈밀" },
          { id: "ssub-eq3-3", name: "Máy Đồng Nhất Hóa Cao Áp", nameKr: "고압 균질기" },
          { id: "ssub-eq3-4", name: "Máy Khuấy Trộn Nano", nameKr: "나노 교반기" },
        ],
      },
      {
        id: "sub-eq4", name: "Thiết Bị Tạo Hình Composite", nameKr: "복합재 성형 설비", productCount: 159,
        subSubCategories: [
          { id: "ssub-eq4-1", name: "Autoclave", nameKr: "오토클레이브" },
          { id: "ssub-eq4-2", name: "Thiết Bị RTM", nameKr: "RTM 성형 장비" },
          { id: "ssub-eq4-3", name: "Máy Ép Composite", nameKr: "복합재 프레스 성형기" },
          { id: "ssub-eq4-4", name: "Máy Quấn Sợi Filament", nameKr: "필라멘트 와인딩 머신" },
          { id: "ssub-eq4-5", name: "Thiết Bị In 3D Composite", nameKr: "복합재 3D 프린터" },
        ],
      },
    ],
  },
  {
    id: "cat-en",
    code: "5",
    name: "Năng Lượng & Pin Thế Hệ Mới",
    nameKr: "에너지 및 차세대 배터리",
    description: "Chất dẫn điện pin, bình chứa hydro, tấm phân ly pin nhiên liệu, ESS",
    image: "https://readdy.ai/api/search-image?query=next%20generation%20battery%20energy%20storage%20hydrogen%20tank%20fuel%20cell%20ESS%20Korean%20technology%20clean%20energy%20green%20sustainable%20innovation%20professional%20studio&width=400&height=300&seq=cat_en1&orientation=landscape",
    productCount: 999,
    color: "from-amber-700 to-amber-900",
    subCategories: [
      {
        id: "sub-en1", name: "Chất Dẫn Điện Pin", nameKr: "배터리용 도전재", productCount: 360,
        subSubCategories: [
          { id: "ssub-en1-1", name: "Carbon Black Dẫn Điện", nameKr: "카본블랙 도전재" },
          { id: "ssub-en1-2", name: "CNT Dẫn Điện Pin", nameKr: "CNT 배터리 도전재" },
          { id: "ssub-en1-3", name: "Graphene Dẫn Điện", nameKr: "그래핀 도전재" },
          { id: "ssub-en1-4", name: "Slurry Dẫn Điện", nameKr: "도전재 슬러리" },
        ],
      },
      {
        id: "sub-en2", name: "Bình Chứa Hydro", nameKr: "수소 저장 탱크", productCount: 250,
        subSubCategories: [
          { id: "ssub-en2-1", name: "Bình Type III (Kim Loại + CFRP)", nameKr: "Type III 탱크 (금속+CFRP)" },
          { id: "ssub-en2-2", name: "Bình Type IV (Nhựa + CFRP)", nameKr: "Type IV 탱크 (플라스틱+CFRP)" },
          { id: "ssub-en2-3", name: "Mô Đun Lưu Trữ Hydro", nameKr: "수소 저장 모듈" },
          { id: "ssub-en2-4", name: "Van & Phụ Kiện Bình Hydro", nameKr: "수소탱크 밸브 및 부속품" },
        ],
      },
      {
        id: "sub-en3", name: "Tấm Phân Ly Pin Nhiên Liệu", nameKr: "연료전지 분리판", productCount: 230,
        subSubCategories: [
          { id: "ssub-en3-1", name: "Tấm Phân Ly Graphite", nameKr: "흑연 분리판" },
          { id: "ssub-en3-2", name: "Tấm Phân Ly Carbon Composite", nameKr: "탄소복합재 분리판" },
          { id: "ssub-en3-3", name: "Tấm Phân Ly Kim Loại", nameKr: "금속 분리판" },
          { id: "ssub-en3-4", name: "MEA (Membrane Electrode Assembly)", nameKr: "막전극접합체 (MEA)" },
        ],
      },
      {
        id: "sub-en4", name: "Hệ Thống Lưu Trữ Năng Lượng (ESS)", nameKr: "에너지 저장장치 (ESS)", productCount: 159,
        subSubCategories: [
          { id: "ssub-en4-1", name: "ESS Lithium-ion", nameKr: "리튬이온 ESS" },
          { id: "ssub-en4-2", name: "ESS Toàn Thể Rắn", nameKr: "전고체 ESS" },
          { id: "ssub-en4-3", name: "Hệ Thống Pin Dòng Chảy", nameKr: "유동전지 시스템" },
          { id: "ssub-en4-4", name: "BMS (Hệ Thống Quản Lý Pin)", nameKr: "배터리 관리 시스템 (BMS)" },
        ],
      },
    ],
  },
  {
    id: "cat-cs",
    code: "6",
    name: "Xây Dựng & Vật Liệu Công Nghiệp",
    nameKr: "건설·건축 및 산업자재",
    description: "Vật liệu ngoại thất tòa nhà, gia cường cầu, bộ lọc công nghiệp, cách nhiệt, composite dân dụng",
    image: "https://readdy.ai/api/search-image?query=construction%20building%20architectural%20industrial%20material%20Korean%20composite%20bridge%20reinforcement%20insulation%20filter%20exterior%20cladding%20modern%20infrastructure%20clean%20professional&width=400&height=300&seq=cat_cs1&orientation=landscape",
    productCount: 999,
    color: "from-stone-700 to-stone-900",
    subCategories: [
      {
        id: "sub-cs1", name: "Vật Liệu Ngoại Thất Tòa Nhà", nameKr: "건축 내외장재", productCount: 320,
        subSubCategories: [
          { id: "ssub-cs1-1", name: "Tấm Ngoại Thất CFRP", nameKr: "CFRP 외장 패널" },
          { id: "ssub-cs1-2", name: "Bê Tông Cốt Sợi Carbon", nameKr: "탄소섬유 강화 콘크리트" },
          { id: "ssub-cs1-3", name: "Vật Liệu Mái Nhẹ", nameKr: "경량 지붕재" },
          { id: "ssub-cs1-4", name: "Tấm Ốp Tường Composite", nameKr: "복합재 외장 클래딩" },
          { id: "ssub-cs1-5", name: "Cửa Sổ & Khung Carbon", nameKr: "탄소복합 창호 프레임" },
        ],
      },
      {
        id: "sub-cs2", name: "Gia Cường Cầu", nameKr: "교량 보강재", productCount: 255,
        subSubCategories: [
          { id: "ssub-cs2-1", name: "Vật Liệu Gia Cường FRP", nameKr: "FRP 보강재" },
          { id: "ssub-cs2-2", name: "Tấm Sợi Carbon (Sheet)", nameKr: "탄소섬유 시트" },
          { id: "ssub-cs2-3", name: "Dải Carbon (Strip/Laminate)", nameKr: "탄소섬유 스트립" },
          { id: "ssub-cs2-4", name: "Thanh CFRP (Rod/Bar)", nameKr: "탄소섬유 로드·바" },
        ],
      },
      {
        id: "sub-cs3", name: "Bộ Lọc Công Nghiệp", nameKr: "산업용 필터", productCount: 210,
        subSubCategories: [
          { id: "ssub-cs3-1", name: "Bộ Lọc Than Hoạt Tính", nameKr: "활성탄소 필터" },
          { id: "ssub-cs3-2", name: "Vật Liệu Lọc Sợi Carbon", nameKr: "탄소섬유 여과재" },
          { id: "ssub-cs3-3", name: "Màng Lọc Nano", nameKr: "나노 필터 멤브레인" },
          { id: "ssub-cs3-4", name: "Bộ Lọc Khí HEPA Carbon", nameKr: "탄소 기반 HEPA 필터" },
        ],
      },
      {
        id: "sub-cs4", name: "Vật Liệu Cách Nhiệt", nameKr: "단열재", productCount: 134,
        subSubCategories: [
          { id: "ssub-cs4-1", name: "Aerogel Cách Nhiệt", nameKr: "에어로겔 단열재" },
          { id: "ssub-cs4-2", name: "Tấm Cách Nhiệt Carbon Composite", nameKr: "탄소복합 단열 패널" },
          { id: "ssub-cs4-3", name: "Nano Insulation Panel (NIP)", nameKr: "나노 단열 패널 (NIP)" },
        ],
      },
      {
        id: "sub-cs5", name: "Composite Dân Dụng", nameKr: "토목용 복합소재", productCount: 80,
        subSubCategories: [
          { id: "ssub-cs5-1", name: "Geogrid Composite", nameKr: "복합소재 지오그리드" },
          { id: "ssub-cs5-2", name: "Cọc Gia Cố Sợi Carbon", nameKr: "탄소섬유 보강 파일" },
          { id: "ssub-cs5-3", name: "Trụ Cầu Composite", nameKr: "복합소재 교각 부품" },
        ],
      },
    ],
  },
  {
    id: "cat-ft",
    code: "7",
    name: "Sợi Chức Năng & Hàng Tiêu Dùng",
    nameKr: "기능성 섬유 및 생활용품",
    description: "Vải may mặc hiệu suất cao, dụng cụ thể thao, vật liệu chăm sóc sức khỏe, nano làm đẹp",
    image: "https://readdy.ai/api/search-image?query=functional%20fiber%20high%20performance%20textile%20sports%20equipment%20healthcare%20beauty%20nano%20material%20Korean%20lifestyle%20consumer%20goods%20premium%20clean%20background&width=400&height=300&seq=cat_ft1&orientation=landscape",
    productCount: 999,
    color: "from-rose-700 to-rose-900",
    subCategories: [
      {
        id: "sub-ft1", name: "Vải May Mặc Hiệu Suất Cao", nameKr: "고기능성 의류 소재", productCount: 380,
        subSubCategories: [
          { id: "ssub-ft1-1", name: "Vải Thể Thao Nano Carbon", nameKr: "나노 탄소 스포츠웨어 원단" },
          { id: "ssub-ft1-2", name: "Vải Chống Đạn (Kevlar/Carbon)", nameKr: "방탄 소재 (케블라/탄소)" },
          { id: "ssub-ft1-3", name: "Vải Chịu Nhiệt", nameKr: "내열 소재" },
          { id: "ssub-ft1-4", name: "Vải Nano Kháng Khuẩn", nameKr: "항균 나노 원단" },
          { id: "ssub-ft1-5", name: "Vải Dẫn Điện (E-Textile)", nameKr: "전도성 전자 섬유" },
        ],
      },
      {
        id: "sub-ft2", name: "Dụng Cụ Thể Thao", nameKr: "스포츠 용품 (라켓 등)", productCount: 290,
        subSubCategories: [
          { id: "ssub-ft2-1", name: "Vợt Carbon (Cầu Lông/Tennis)", nameKr: "탄소섬유 라켓 (배드민턴/테니스)" },
          { id: "ssub-ft2-2", name: "Xe Đạp Carbon", nameKr: "탄소섬유 자전거 프레임" },
          { id: "ssub-ft2-3", name: "Gậy Golf Carbon", nameKr: "탄소섬유 골프 클럽" },
          { id: "ssub-ft2-4", name: "Cần Câu Carbon", nameKr: "탄소섬유 낚싯대" },
          { id: "ssub-ft2-5", name: "Mũ Bảo Hiểm Carbon", nameKr: "탄소섬유 헬멧" },
        ],
      },
      {
        id: "sub-ft3", name: "Vật Liệu Chăm Sóc Sức Khỏe", nameKr: "헬스케어 소재", productCount: 199,
        subSubCategories: [
          { id: "ssub-ft3-1", name: "Sợi Carbon Y Tế", nameKr: "의료용 탄소섬유" },
          { id: "ssub-ft3-2", name: "Vật Liệu Dụng Cụ Trợ Giúp", nameKr: "보조기기 소재" },
          { id: "ssub-ft3-3", name: "Sản Phẩm Nano Kháng Khuẩn", nameKr: "나노 항균 제품" },
          { id: "ssub-ft3-4", name: "Vật Liệu Cấy Ghép Y Tế", nameKr: "의료용 임플란트 소재" },
        ],
      },
      {
        id: "sub-ft4", name: "Nano Làm Đẹp (Beauty Nano)", nameKr: "뷰티 나노소재", productCount: 130,
        subSubCategories: [
          { id: "ssub-ft4-1", name: "Mỹ Phẩm Nano Capsule", nameKr: "나노 캡슐 화장품" },
          { id: "ssub-ft4-2", name: "Nano Bạc (Ag) Làm Đẹp", nameKr: "나노 은 (Ag) 뷰티 소재" },
          { id: "ssub-ft4-3", name: "Nano Ceramic Dưỡng Da", nameKr: "나노 세라믹 스킨케어 소재" },
          { id: "ssub-ft4-4", name: "Nano Carbon Chăm Sóc Tóc", nameKr: "나노 탄소 헤어케어 소재" },
        ],
      },
    ],
  },
  {
    id: "cat-ot",
    code: "8",
    name: "Ngành Khác (Nghiên Cứu · Hỗ Trợ)",
    nameKr: "기타 업종 (연구·지원)",
    description: "Dịch vụ phân tích thử nghiệm, phần mềm thiết kế, viện nghiên cứu, đại học, tư vấn & thương mại",
    image: "https://readdy.ai/api/search-image?query=Korean%20research%20laboratory%20university%20consulting%20trade%20service%20testing%20analysis%20design%20software%20scientific%20institution%20professional%20clean%20minimal%20background&width=400&height=300&seq=cat_ot1&orientation=landscape",
    productCount: 999,
    color: "from-emerald-700 to-emerald-900",
    subCategories: [
      {
        id: "sub-ot1", name: "Dịch Vụ Phân Tích & Thử Nghiệm", nameKr: "시험 분석 서비스", productCount: 320,
        subSubCategories: [
          { id: "ssub-ot1-1", name: "Phân Tích Tính Chất Vật Liệu", nameKr: "물성 분석 서비스" },
          { id: "ssub-ot1-2", name: "Đánh Giá Hiệu Năng", nameKr: "성능 평가 서비스" },
          { id: "ssub-ot1-3", name: "Dịch Vụ Chứng Nhận/Kiểm Định", nameKr: "인증 및 검정 서비스" },
          { id: "ssub-ot1-4", name: "Phân Tích Nano & Micro", nameKr: "나노·마이크로 분석" },
        ],
      },
      {
        id: "sub-ot2", name: "Phần Mềm Thiết Kế", nameKr: "설계 소프트웨어", productCount: 240,
        subSubCategories: [
          { id: "ssub-ot2-1", name: "Phần Mềm CAE Composite", nameKr: "복합재 CAE 소프트웨어" },
          { id: "ssub-ot2-2", name: "Công Cụ Thiết Kế Composite", nameKr: "복합재 설계 툴" },
          { id: "ssub-ot2-3", name: "Dịch Vụ Phân Tích Mô Phỏng", nameKr: "시뮬레이션 해석 서비스" },
        ],
      },
      {
        id: "sub-ot3", name: "Viện Nghiên Cứu & Đại Học", nameKr: "연구소, 대학", productCount: 220,
        subSubCategories: [
          { id: "ssub-ot3-1", name: "Viện Nghiên Cứu Nhà Nước", nameKr: "정부출연 연구소" },
          { id: "ssub-ot3-2", name: "Phòng Thí Nghiệm Đại Học", nameKr: "대학교 연구실" },
          { id: "ssub-ot3-3", name: "Trung Tâm R&D Doanh Nghiệp", nameKr: "기업부설 연구소" },
        ],
      },
      {
        id: "sub-ot4", name: "Tư Vấn & Thương Mại", nameKr: "컨설팅 및 무역", productCount: 219,
        subSubCategories: [
          { id: "ssub-ot4-1", name: "Tư Vấn Kỹ Thuật", nameKr: "기술 컨설팅" },
          { id: "ssub-ot4-2", name: "Xuất Nhập Khẩu Thương Mại", nameKr: "수출입 무역" },
          { id: "ssub-ot4-3", name: "Kết Nối Kinh Doanh B2B", nameKr: "B2B 비즈니스 매칭" },
          { id: "ssub-ot4-4", name: "Dịch Vụ Xúc Tiến Thương Mại", nameKr: "무역 진흥 서비스" },
        ],
      },
    ],
  },
];
